<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" class="btn btn-fill btn-primary" @click="$router.push('/orders/create')">
          <i class="fa fa-plus"></i> Anlegen
        </button>
      </div>
      <div class="row">
        <div class="col-sm-6">
            <label>Zeitraum</label>
          <div class="form-group has-label">
            <el-date-picker v-model="dateRange" type="daterange" range-separator="Bis" start-placeholder="Anfangsdatum"
              end-placeholder="Enddatum" format="dd.MM.yyyy" value-format="yyyy-MM-dd" @change="filterData"
              :picker-options="{ firstDayOfWeek: 1 }" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
            <label>Lieferant</label>
          <div class="form-group has-label">
            <multiselect v-model="supplier" :options="suppliers" track-by="id" label="name" @input="filterData" />
          </div>
        </div>
        <div class="col-sm-2">
            <label>Status</label>
          <div class="form-group has-label">
            <multiselect v-model="status" :options="statusOptions" :multiple="true" track-by="value" label="label"
              @input="filterData" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3" v-if="locations.length">
            <label>Standorte</label>
          <div class="form-group has-label">
            <multiselect v-model="location" :options="locations" track-by="id" label="name" @input="filterData" />
          </div>
        </div>
        <div class="col-sm-4">
            <label>Lager</label>
          <div class="form-group has-label">
            <multiselect v-model="warehouse" :options="warehouses" track-by="id" label="name" @input="filterData" />
          </div>
        </div>
      </div>

      <br>
      <transition name="el-fade-in-linear">
        <orders-table v-if="!loading && orders.length" :orders="orders"
        @updateOrders="updateOrders"
        />
      </transition>
      <p v-if="!loading && !orders.length">Keine Bestellungen gefunden</p>
      <l-pagination v-if="orders.length && pageCount > 1" background layout="prev, pager, next" :per-page="10"
        :page-count="pageCount" :value="currentPage" @input="changePage" @changePerPage="changePerPage" />
    </card>
  </div>
</template>

<script>
import OrdersTable from './orders-table'
import hasPagination from 'src/has-pagination'
import { DatePicker } from 'element-ui'

export default {
  components: {
    OrdersTable,
    [DatePicker.name]: DatePicker
  },
  mixins: [hasPagination],
  data() {
    return {
      firstLoad: true,
      orders: [],
      loading: true,
      dateRange: null,
      supplier: null,
      suppliers: [],
      warehouses: [],
      warehouse: null,
      locations: [],
      location: null,
      status: [
        // { value: 'open', label: 'Offen' },
        // { value: 'waiting', label: 'Wartet auf Freigabe' }
      ],
      statusOptions: [
        { value: 'open', label: 'Offen' },
        { value: 'waiting', label: 'Wartet auf Freigabe' },
        { value: 'ordered', label: 'Bestellt' },
        { value: 'problem', label: 'Problem' },
        { value: 'incomplete', label: 'Unvollständig geliefert' },
        { value: 'finished', label: 'Abgeschlossen' },
        { value: 'storno', label: 'Storniert' }
      ]
    }
  },
  methods: {
    updateOrders() {
      this.fetchTableData()
    },
    getCustomQueryData() {
      const customQueryData = {
        supplier: this.supplier ? this.supplier.id : (this.firstLoad ? (this.$route.query['supplier'] || '') : ''),
        date_range: this.dateRange ? encodeURIComponent(this.dateRange) : '',
        status: this.status.length ? encodeURIComponent(this.status.map(status => status.value)) : '',
        warehouse: this.warehouse ? this.warehouse.id : '',
        location: this.location ? this.location.id : '',
      }
      this.firstLoad = false
      return customQueryData
    },
    filterData() {
      this.currentPage = 1
      this.loading = true
      this.fetchTableData()
    },
    getData(query) {
      this.$http.get(`/orders?${query}`).then(({ data }) => {
        this.orders = data.data
        this.pageCount = data.last_page
        this.loading = false
      })
    }
  },
  created() {
    this.fetchTableData()
    this.$http.get('/suppliers').then(({ data }) => { this.suppliers = data })
    this.$http.get('/warehouses').then(({ data }) => { this.warehouses = data })
    this.$http.get('/locations').then(({ data }) => { this.locations = data })
    if (this.$route.query['supplier']) {
      this.$http.get(`/suppliers/${this.$route.query['supplier']}`).then(({ data }) => {
        this.supplier = data

      })
    }
  }
}
</script>
